import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/input";

/** Chip-style tag input. Type + Enter (or comma) to add a tag. */
export default function TagInput({ value = [], onChange, placeholder = "Type and press Enter…", testid = "tag-input" }) {
  const [draft, setDraft] = useState("");

  const add = (raw) => {
    const t = (raw || "").trim();
    if (!t) return;
    if (value.includes(t)) { setDraft(""); return; }
    onChange?.([...value, t]);
    setDraft("");
  };
  const remove = (t) => onChange?.(value.filter((x) => x !== t));

  return (
    <div className="rounded-md border bg-background px-2 py-1.5 flex flex-wrap gap-1.5 items-center focus-within:ring-2 focus-within:ring-ring">
      {value.map((t) => (
        <span key={t} className="inline-flex items-center gap-1 rounded-full bg-secondary px-2 py-0.5 text-xs" data-testid={`${testid}-chip-${t}`}>
          {t}
          <button type="button" onClick={() => remove(t)} className="opacity-70 hover:opacity-100" data-testid={`${testid}-remove-${t}`}>
            <X className="w-3 h-3" />
          </button>
        </span>
      ))}
      <Input
        data-testid={`${testid}-input`}
        className="border-0 shadow-none focus-visible:ring-0 h-7 px-1 flex-1 min-w-[120px]"
        placeholder={value.length === 0 ? placeholder : ""}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); }
          else if (e.key === "Backspace" && !draft && value.length) { remove(value[value.length - 1]); }
        }}
        onBlur={() => add(draft)}
      />
    </div>
  );
}
